import { render } from "./Authors.vue?vue&type=template&id=be7a6e14&scoped=true"
import script from "./Authors.vue?vue&type=script&lang=js"
export * from "./Authors.vue?vue&type=script&lang=js"

import "./Authors.vue?vue&type=style&index=0&id=be7a6e14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-be7a6e14"

export default script